
export default {
  name: 'rzTextarea',
  props: {
    rows: {
      type: [Number, String],
      default: 3,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: { type: String, default: '' },
    chat: Boolean,
    withoutLabel: Boolean,
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  methods: {
    autosize() {
      const el = this.$refs.textarea;
      setTimeout(() => {
        el.style.cssText = 'height:auto; padding:0';
        el.style.cssText = `height:${el.scrollHeight}px`;
      },0);
    },
    addLineBreak() {
      this.value += '\n';
      this.autosize();
    },
    change(event){
      this.$emit('input', event.target.value);
    },
  },
};
